/* Generated by ai2react v0.102.0 - 2021-09-14 00:49 */
/* ai file: 01-ranking-shanghai-academic-ranking-of-world-universities-2021.ai */

import { makeAi2React } from './src/index'
import img0 from './img/01-ranking-shanghai-academic-ranking-of-world-universities-2021-large.svg'
import img1 from './img/01-ranking-shanghai-academic-ranking-of-world-universities-2021-mobile.svg'

const styles = `
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-box ,
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-box .g-artboard {
    margin:0 auto;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-box p {
    margin:0;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-box .g-aiAbs {
    position:absolute;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-box .g-aiImg {
    position:absolute;
    top:0;
    display:block;
    width:100% !important;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-box .g-aiPointText p { white-space: nowrap; }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-large {
    position:relative;
    overflow:hidden;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-large p {
    font-family:Inter;
    font-weight:400;
    line-height:12px;
    filter:alpha(opacity=100);
    -ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
    opacity:1;
    letter-spacing:-0.029em;
    font-size:10px;
    text-align:left;
    color:rgb(0,0,0);
    text-transform:none;
    padding-bottom:0;
    padding-top:0;
    mix-blend-mode:normal;
    font-style:normal;
    height:auto;
    position:static;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-large .g-pstyle0 {
    font-weight:800;
    line-height:20px;
    height:20px;
    letter-spacing:-0.02em;
    font-size:16px;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-large .g-pstyle1 {
    font-weight:700;
    height:12px;
    letter-spacing:-0.019em;
    color:rgb(236,28,36);
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-large .g-pstyle2 {
    font-weight:700;
    line-height:10px;
    height:10px;
    letter-spacing:-0.02em;
    font-size:9px;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-large .g-pstyle3 {
    font-weight:700;
    line-height:9px;
    height:9px;
    letter-spacing:-0.02em;
    font-size:8px;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-large .g-pstyle4 {
    font-weight:700;
    line-height:9px;
    height:9px;
    letter-spacing:-0.019em;
    font-size:8px;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-large .g-pstyle5 {
    line-height:11px;
    height:11px;
    font-size:9px;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-large .g-pstyle6 {
    line-height:10px;
    height:10px;
    font-size:8px;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-large .g-pstyle7 {
    line-height:10px;
    height:10px;
    letter-spacing:0em;
    font-size:8px;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-large .g-pstyle8 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.03em;
    font-size:8px;
    color:rgb(88,89,91);
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-large .g-pstyle9 {
    line-height:9px;
    height:9px;
    letter-spacing:0em;
    font-size:8px;
    color:rgb(255,255,255);
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-large .g-pstyle10 {
    line-height:10px;
    height:10px;
    font-size:8px;
    color:rgb(88,89,91);
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-large .g-pstyle11 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.03em;
    font-size:8px;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-large .g-pstyle12 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.042em;
    font-size:8px;
    color:rgb(88,89,91);
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-large .g-pstyle13 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.084em;
    font-size:8px;
    color:rgb(88,89,91);
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-large .g-pstyle14 {
    height:12px;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-large .g-pstyle15 {
    font-weight:700;
    line-height:10px;
    height:10px;
    letter-spacing:-0.019em;
    font-size:9px;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-large .g-pstyle16 {
    line-height:11px;
    height:11px;
    letter-spacing:-0.03em;
    font-size:9px;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-large .g-pstyle17 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.049em;
    font-size:8px;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-large .g-pstyle18 {
    line-height:9px;
    height:9px;
    letter-spacing:-0.019em;
    font-size:8px;
    color:rgb(255,255,255);
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-large .g-pstyle19 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.036em;
    font-size:8px;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-large .g-pstyle20 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.045em;
    font-size:8px;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-large .g-pstyle21 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.076em;
    font-size:8px;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-large .g-cstyle0 {
    letter-spacing:-0.019em;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-large .g-cstyle1 {
    letter-spacing:0em;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-large .g-cstyle2 {
    letter-spacing:-0.02em;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-large .g-cstyle3 {
    letter-spacing:-0.033em;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-large .g-cstyle4 {
    letter-spacing:-0.03em;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-large .g-cstyle5 {
    letter-spacing:-0.029em;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-large .g-cstyle6 {
    letter-spacing:-0.037em;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-large .g-cstyle7 {
    letter-spacing:-0.036em;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-large .g-cstyle8 {
    letter-spacing:-0.032em;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-large .g-cstyle9 {
    letter-spacing:-0.035em;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-large .g-cstyle10 {
    letter-spacing:-0.116em;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-large .g-cstyle11 {
    letter-spacing:-0.014em;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-large .g-cstyle12 {
    letter-spacing:-0.042em;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-large .g-cstyle13 {
    letter-spacing:-0.038em;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-large .g-cstyle14 {
    letter-spacing:-0.09em;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-large .g-cstyle15 {
    letter-spacing:-0.053em;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-large .g-cstyle16 {
    letter-spacing:-0.039em;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-large .g-cstyle17 {
    letter-spacing:-0.048em;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-large .g-cstyle18 {
    letter-spacing:-0.041em;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-large .g-cstyle19 {
    letter-spacing:-0.061em;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-large .g-cstyle20 {
    letter-spacing:-0.049em;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-large .g-cstyle21 {
    letter-spacing:-0.097em;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-large .g-cstyle22 {
    letter-spacing:-0.04em;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-large .g-cstyle23 {
    letter-spacing:-0.047em;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-mobile {
    position:relative;
    overflow:hidden;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-mobile p {
    font-family:Inter;
    font-weight:400;
    line-height:12px;
    filter:alpha(opacity=100);
    -ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
    opacity:1;
    letter-spacing:-0.029em;
    font-size:10px;
    text-align:left;
    color:rgb(0,0,0);
    text-transform:none;
    padding-bottom:0;
    padding-top:0;
    mix-blend-mode:normal;
    font-style:normal;
    height:auto;
    position:static;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-mobile .g-pstyle0 {
    font-weight:800;
    line-height:20px;
    height:20px;
    letter-spacing:-0.02em;
    font-size:16px;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-mobile .g-pstyle1 {
    font-weight:700;
    line-height:10px;
    height:10px;
    letter-spacing:-0.02em;
    font-size:9px;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-mobile .g-pstyle2 {
    font-weight:700;
    height:12px;
    letter-spacing:-0.019em;
    color:rgb(236,28,36);
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-mobile .g-pstyle3 {
    font-weight:700;
    line-height:9px;
    height:9px;
    letter-spacing:-0.02em;
    font-size:8px;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-mobile .g-pstyle4 {
    font-weight:700;
    line-height:9px;
    height:9px;
    letter-spacing:-0.019em;
    font-size:8px;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-mobile .g-pstyle5 {
    line-height:11px;
    height:11px;
    font-size:9px;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-mobile .g-pstyle6 {
    line-height:10px;
    height:10px;
    font-size:8px;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-mobile .g-pstyle7 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.03em;
    font-size:8px;
    color:rgb(88,89,91);
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-mobile .g-pstyle8 {
    line-height:9px;
    height:9px;
    letter-spacing:0em;
    font-size:8px;
    color:rgb(255,255,255);
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-mobile .g-pstyle9 {
    line-height:10px;
    height:10px;
    font-size:8px;
    color:rgb(88,89,91);
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-mobile .g-pstyle10 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.03em;
    font-size:8px;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-mobile .g-pstyle11 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.042em;
    font-size:8px;
    color:rgb(88,89,91);
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-mobile .g-pstyle12 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.084em;
    font-size:8px;
    color:rgb(88,89,91);
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-mobile .g-pstyle13 {
    height:12px;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-mobile .g-pstyle14 {
    font-weight:700;
    line-height:10px;
    height:10px;
    letter-spacing:-0.019em;
    font-size:9px;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-mobile .g-pstyle15 {
    line-height:11px;
    height:11px;
    letter-spacing:-0.03em;
    font-size:9px;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-mobile .g-pstyle16 {
    line-height:10px;
    height:10px;
    letter-spacing:0em;
    font-size:8px;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-mobile .g-pstyle17 {
    line-height:9px;
    height:9px;
    letter-spacing:-0.019em;
    font-size:8px;
    color:rgb(255,255,255);
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-mobile .g-pstyle18 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.049em;
    font-size:8px;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-mobile .g-pstyle19 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.036em;
    font-size:8px;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-mobile .g-pstyle20 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.045em;
    font-size:8px;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-mobile .g-pstyle21 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.076em;
    font-size:8px;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-mobile .g-cstyle0 {
    letter-spacing:-0.019em;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-mobile .g-cstyle1 {
    letter-spacing:0em;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-mobile .g-cstyle2 {
    letter-spacing:-0.02em;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-mobile .g-cstyle3 {
    letter-spacing:-0.033em;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-mobile .g-cstyle4 {
    letter-spacing:-0.03em;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-mobile .g-cstyle5 {
    letter-spacing:-0.029em;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-mobile .g-cstyle6 {
    letter-spacing:-0.037em;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-mobile .g-cstyle7 {
    letter-spacing:-0.036em;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-mobile .g-cstyle8 {
    letter-spacing:-0.032em;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-mobile .g-cstyle9 {
    letter-spacing:-0.035em;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-mobile .g-cstyle10 {
    letter-spacing:-0.116em;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-mobile .g-cstyle11 {
    letter-spacing:-0.014em;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-mobile .g-cstyle12 {
    letter-spacing:-0.042em;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-mobile .g-cstyle13 {
    letter-spacing:-0.038em;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-mobile .g-cstyle14 {
    letter-spacing:-0.09em;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-mobile .g-cstyle15 {
    letter-spacing:-0.053em;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-mobile .g-cstyle16 {
    letter-spacing:-0.039em;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-mobile .g-cstyle17 {
    letter-spacing:-0.048em;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-mobile .g-cstyle18 {
    letter-spacing:-0.041em;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-mobile .g-cstyle19 {
    letter-spacing:-0.061em;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-mobile .g-cstyle20 {
    letter-spacing:-0.049em;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-mobile .g-cstyle21 {
    letter-spacing:-0.097em;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-mobile .g-cstyle22 {
    letter-spacing:-0.04em;
  }
  #g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-mobile .g-cstyle23 {
    letter-spacing:-0.047em;
  }

`

const html = props => `
<div id="g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-box" class="ai2html">


  <!-- Artboard: large -->
  <div id="g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-large" class="g-artboard" style="width:800px; height:693px;" data-aspect-ratio="1.154" data-min-width="800">
<div style=""></div>
    <img id="g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-large-img" class="g-aiImg" alt="" src="${img0}"/>
    <div id="g-ai0-1" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:2.8347%;margin-top:-11.6px;left:1.4518%;width:432px;">
      <p class="g-pstyle0">ACAD<span class="g-cstyle0">E</span>MIC RANKI<span class="g-cstyle0">N</span>G OF <span class="g-cstyle0">W</span>ORLD UNIV<span class="g-cstyle0">E</span>RSI<span class="g-cstyle0">T</span>I<span class="g-cstyle0">E</span>S 202<span class="g-cstyle1">1</span></p>
    </div>
    <div id="g-ai0-2" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:5.8855%;margin-top:-6.8px;left:13.7281%;width:71px;">
      <p class="g-pstyle1"><span class="g-cstyle2">I</span>ns<span class="g-cstyle2">t</span>i<span class="g-cstyle2">t</span>u<span class="g-cstyle2">c</span>ió<span class="g-cstyle1">n</span></p>
    </div>
    <div id="g-ai0-3" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:5.8649%;margin-top:-5.6px;left:1.9678%;width:63px;">
      <p class="g-pstyle2">RA<span class="g-cstyle0">N</span>KI<span class="g-cstyle0">N</span>G<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-4" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:5.8649%;margin-top:-5.6px;left:60.2228%;width:63px;">
      <p class="g-pstyle2">RA<span class="g-cstyle0">N</span>KI<span class="g-cstyle0">N</span>G<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-5" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:5.7721%;margin-top:-5px;left:50.4186%;width:37px;">
      <p class="g-pstyle3">P<span class="g-cstyle0">a</span>í<span class="g-cstyle1">s</span></p>
    </div>
    <div id="g-ai0-6" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:5.7721%;margin-top:-5px;left:73.3232%;width:51px;">
      <p class="g-pstyle4">Pun<span class="g-cstyle2">ta</span>j<span class="g-cstyle2">e</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-7" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:7.0193%;margin-top:-5.6px;left:1.9678%;width:62px;">
      <p class="g-pstyle2">MU<span class="g-cstyle0">N</span>DIA<span class="g-cstyle1">L</span></p>
    </div>
    <div id="g-ai0-8" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:7.0193%;margin-top:-5.6px;left:59.8228%;width:67px;">
      <p class="g-pstyle2"><span class="g-cstyle0">N</span>ACIO<span class="g-cstyle0">N</span>A<span class="g-cstyle1">L</span></p>
    </div>
    <div id="g-ai0-9" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:10.7453%;margin-top:-6.5px;left:9.2454%;width:122px;">
      <p class="g-pstyle5"><span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>v<span class="g-cstyle4">er</span>s<span class="g-cstyle4">i</span>d<span class="g-cstyle4">a</span>d d<span class="g-cstyle4">e </span>Ha<span class="g-cstyle4">r</span>vard<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-10" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:10.9876%;margin-top:-6.1px;left:49.0247%;width:83px;">
      <p class="g-pstyle6"><span class="g-cstyle4">E</span>st<span class="g-cstyle4">ad</span>o<span class="g-cstyle4">s</span> <span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>d<span class="g-cstyle4">o</span>s<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-11" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:10.9876%;margin-top:-6.1px;left:62.5332%;width:28px;">
      <p class="g-pstyle7"><span class="g-cstyle5">1</span> </p>
    </div>
    <div id="g-ai0-12" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:10.9876%;margin-top:-6.1px;left:67.47%;width:45px;">
      <p class="g-pstyle8">1<span class="g-cstyle5">0</span><span class="g-cstyle6">0</span><span class="g-cstyle7">.</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-13" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:10.8226%;margin-top:-5px;left:4.3091%;width:28px;">
      <p class="g-pstyle9"><span class="g-cstyle0">1</span> </p>
    </div>
    <div id="g-ai0-14" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:15.5072%;margin-top:-6.5px;left:9.2454%;width:125px;">
      <p class="g-pstyle5"><span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>v<span class="g-cstyle4">er</span>s<span class="g-cstyle4">i</span>d<span class="g-cstyle4">a</span>d d<span class="g-cstyle4">e </span><span class="g-cstyle8">S</span>ta<span class="g-cstyle3">n</span><span class="g-cstyle4">f</span>o<span class="g-cstyle4">r</span>d<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-15" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:15.7495%;margin-top:-6.1px;left:49.0247%;width:83px;">
      <p class="g-pstyle6"><span class="g-cstyle4">E</span>st<span class="g-cstyle4">ad</span>o<span class="g-cstyle4">s</span> <span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>d<span class="g-cstyle4">o</span>s<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-16" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:15.7495%;margin-top:-6.1px;left:62.51%;width:29px;">
      <p class="g-pstyle7"><span class="g-cstyle4">2</span> </p>
    </div>
    <div id="g-ai0-17" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:15.7495%;margin-top:-6.1px;left:68.171%;width:41px;">
      <p class="g-pstyle10">75<span class="g-cstyle9">.</span>9<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-18" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:15.5845%;margin-top:-5px;left:4.2863%;width:29px;">
      <p class="g-pstyle9"><span class="g-cstyle0">2</span> </p>
    </div>
    <div id="g-ai0-19" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:20.1248%;margin-top:-6.5px;left:9.2454%;width:135px;">
      <p class="g-pstyle5"><span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>v<span class="g-cstyle4">er</span>s<span class="g-cstyle4">i</span>d<span class="g-cstyle4">a</span>d d<span class="g-cstyle4">e </span>Cambr<span class="g-cstyle4">i</span>dge<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-20" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:20.3671%;margin-top:-6.1px;left:49.0247%;width:70px;">
      <p class="g-pstyle11"><span class="g-cstyle5">Re</span>in<span class="g-cstyle5">o</span> <span class="g-cstyle8">U</span>nid<span class="g-cstyle5">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-21" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:20.3671%;margin-top:-6.1px;left:62.5332%;width:28px;">
      <p class="g-pstyle7"><span class="g-cstyle5">1</span> </p>
    </div>
    <div id="g-ai0-22" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:20.3671%;margin-top:-6.1px;left:68.1246%;width:41px;">
      <p class="g-pstyle10">7<span class="g-cstyle7">0</span><span class="g-cstyle6">.</span>6<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-23" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:20.3464%;margin-top:-5px;left:4.2938%;width:29px;">
      <p class="g-pstyle9"><span class="g-cstyle0">3</span> </p>
    </div>
    <div id="g-ai0-24" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:24.8867%;margin-top:-6.5px;left:9.2454%;width:212px;">
      <p class="g-pstyle5">I<span class="g-cstyle4">n</span>st<span class="g-cstyle4">it</span>ut<span class="g-cstyle4">o</span> <span class="g-cstyle10">T</span><span class="g-cstyle4">e</span>c<span class="g-cstyle4">n</span>ol<span class="g-cstyle4">ó</span>gi<span class="g-cstyle4">co</span> de Ma<span class="g-cstyle4">s</span>sac<span class="g-cstyle4">h</span>u<span class="g-cstyle4">se</span>tt<span class="g-cstyle4">s </span>(MI<span class="g-cstyle11">T</span>)<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-25" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:25.129%;margin-top:-6.1px;left:49.0247%;width:83px;">
      <p class="g-pstyle6"><span class="g-cstyle4">E</span>st<span class="g-cstyle4">ad</span>o<span class="g-cstyle4">s</span> <span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>d<span class="g-cstyle4">o</span>s<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-26" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:25.129%;margin-top:-6.1px;left:62.5175%;width:29px;">
      <p class="g-pstyle7"><span class="g-cstyle5">3</span> </p>
    </div>
    <div id="g-ai0-27" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:25.129%;margin-top:-6.1px;left:68.1246%;width:41px;">
      <p class="g-pstyle10">6<span class="g-cstyle12">9</span>.<span class="g-cstyle4">5</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-28" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:24.964%;margin-top:-5px;left:4.2635%;width:29px;">
      <p class="g-pstyle9"><span class="g-cstyle0">4</span> </p>
    </div>
    <div id="g-ai0-29" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:29.5043%;margin-top:-6.5px;left:9.2454%;width:168px;">
      <p class="g-pstyle5"><span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>v<span class="g-cstyle4">er</span>s<span class="g-cstyle4">i</span>d<span class="g-cstyle4">a</span>d d<span class="g-cstyle4">e </span>Ca<span class="g-cstyle4">l</span>i<span class="g-cstyle4">f</span>o<span class="g-cstyle4">r</span>nia, B<span class="g-cstyle4">er</span><span class="g-cstyle13">k</span>el<span class="g-cstyle4">e</span>y<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-30" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:29.7466%;margin-top:-6.1px;left:49.0247%;width:83px;">
      <p class="g-pstyle6"><span class="g-cstyle4">E</span>st<span class="g-cstyle4">ad</span>o<span class="g-cstyle4">s</span> <span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>d<span class="g-cstyle4">o</span>s<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-31" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:29.7466%;margin-top:-6.1px;left:62.4868%;width:30px;">
      <p class="g-pstyle7"><span class="g-cstyle4">4</span> </p>
    </div>
    <div id="g-ai0-32" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:29.7466%;margin-top:-6.1px;left:68.0635%;width:41px;">
      <p class="g-pstyle10">66<span class="g-cstyle6">.</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-33" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:29.7259%;margin-top:-5px;left:4.2938%;width:29px;">
      <p class="g-pstyle9"><span class="g-cstyle0">5</span> </p>
    </div>
    <div id="g-ai0-34" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:34.2662%;margin-top:-6.5px;left:9.2454%;width:130px;">
      <p class="g-pstyle5"><span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>v<span class="g-cstyle4">er</span>s<span class="g-cstyle4">i</span>d<span class="g-cstyle4">a</span>d d<span class="g-cstyle4">e </span>P<span class="g-cstyle4">ri</span>n<span class="g-cstyle4">ce</span>to<span class="g-cstyle4">n</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-35" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:34.5085%;margin-top:-6.1px;left:49.0247%;width:83px;">
      <p class="g-pstyle6"><span class="g-cstyle4">E</span>st<span class="g-cstyle4">ad</span>o<span class="g-cstyle4">s</span> <span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>d<span class="g-cstyle4">o</span>s<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-36" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:34.5085%;margin-top:-6.1px;left:62.5175%;width:29px;">
      <p class="g-pstyle7"><span class="g-cstyle5">5</span> </p>
    </div>
    <div id="g-ai0-37" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:34.5085%;margin-top:-6.1px;left:68.1868%;width:41px;">
      <p class="g-pstyle12"><span class="g-cstyle4">5</span>9<span class="g-cstyle9">.</span><span class="g-cstyle5">7</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-38" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:34.4878%;margin-top:-5px;left:4.2786%;width:29px;">
      <p class="g-pstyle9"><span class="g-cstyle0">6</span> </p>
    </div>
    <div id="g-ai0-39" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:39.0282%;margin-top:-6.5px;left:9.2454%;width:117px;">
      <p class="g-pstyle5"><span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>v<span class="g-cstyle4">er</span>s<span class="g-cstyle4">i</span>d<span class="g-cstyle4">a</span>d d<span class="g-cstyle4">e </span>Ox<span class="g-cstyle4">fo</span>rd<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-40" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:39.2704%;margin-top:-6.1px;left:49.0247%;width:70px;">
      <p class="g-pstyle11"><span class="g-cstyle5">Re</span>in<span class="g-cstyle5">o</span> <span class="g-cstyle8">U</span>nid<span class="g-cstyle5">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-41" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:39.2704%;margin-top:-6.1px;left:62.51%;width:29px;">
      <p class="g-pstyle7"><span class="g-cstyle4">2</span> </p>
    </div>
    <div id="g-ai0-42" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:39.2704%;margin-top:-6.1px;left:68.1478%;width:41px;">
      <p class="g-pstyle10"><span class="g-cstyle4">5</span><span class="g-cstyle12">9</span>.2<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-43" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:39.1054%;margin-top:-5px;left:4.3015%;width:28px;">
      <p class="g-pstyle9"><span class="g-cstyle0">7</span> </p>
    </div>
    <div id="g-ai0-44" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:43.6458%;margin-top:-6.5px;left:9.2454%;width:128px;">
      <p class="g-pstyle5"><span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>v<span class="g-cstyle4">er</span>s<span class="g-cstyle4">i</span>d<span class="g-cstyle4">a</span>d d<span class="g-cstyle4">e </span>Co<span class="g-cstyle4">l</span>umbia<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-45" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:43.888%;margin-top:-6.1px;left:49.0247%;width:83px;">
      <p class="g-pstyle6"><span class="g-cstyle4">E</span>st<span class="g-cstyle4">ad</span>o<span class="g-cstyle4">s</span> <span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>d<span class="g-cstyle4">o</span>s<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-46" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:43.888%;margin-top:-6.1px;left:62.5026%;width:29px;">
      <p class="g-pstyle7"><span class="g-cstyle5">6</span> </p>
    </div>
    <div id="g-ai0-47" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:43.888%;margin-top:-6.1px;left:68.094%;width:41px;">
      <p class="g-pstyle10"><span class="g-cstyle4">5</span>8<span class="g-cstyle6">.</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-48" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:43.8673%;margin-top:-5px;left:4.2786%;width:29px;">
      <p class="g-pstyle9"><span class="g-cstyle0">8</span> </p>
    </div>
    <div id="g-ai0-49" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:48.4077%;margin-top:-6.5px;left:9.2454%;width:213px;">
      <p class="g-pstyle5">I<span class="g-cstyle4">n</span>st<span class="g-cstyle4">it</span>ut<span class="g-cstyle4">o</span> <span class="g-cstyle10">T</span><span class="g-cstyle4">e</span>c<span class="g-cstyle4">n</span>ol<span class="g-cstyle4">ó</span>gi<span class="g-cstyle4">co</span> de Cal<span class="g-cstyle4">i</span>f<span class="g-cstyle4">o</span>r<span class="g-cstyle4">ni</span>a <span class="g-cstyle4">(</span>CA<span class="g-cstyle14">L</span>T<span class="g-cstyle9">E</span>C<span class="g-cstyle4">H</span>)<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-50" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:48.6499%;margin-top:-6.1px;left:49.0247%;width:83px;">
      <p class="g-pstyle6"><span class="g-cstyle4">E</span>st<span class="g-cstyle4">ad</span>o<span class="g-cstyle4">s</span> <span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>d<span class="g-cstyle4">o</span>s<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-51" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:48.6499%;margin-top:-6.1px;left:62.5259%;width:29px;">
      <p class="g-pstyle7"><span class="g-cstyle5">7</span> </p>
    </div>
    <div id="g-ai0-52" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:48.6499%;margin-top:-6.1px;left:68.2332%;width:40px;">
      <p class="g-pstyle13"><span class="g-cstyle4">5</span>7<span class="g-cstyle9">.</span><span class="g-cstyle5">9</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-53" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:48.4849%;margin-top:-5px;left:4.2786%;width:29px;">
      <p class="g-pstyle9"><span class="g-cstyle0">9</span> </p>
    </div>
    <div id="g-ai0-54" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:53.0252%;margin-top:-6.5px;left:9.2454%;width:121px;">
      <p class="g-pstyle5"><span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>v<span class="g-cstyle4">er</span>s<span class="g-cstyle4">i</span>d<span class="g-cstyle4">a</span>d d<span class="g-cstyle4">e </span>Ch<span class="g-cstyle4">ic</span>ag<span class="g-cstyle1">o</span></p>
    </div>
    <div id="g-ai0-55" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:53.2675%;margin-top:-6.1px;left:49.0247%;width:81px;">
      <p class="g-pstyle6"><span class="g-cstyle4">E</span>st<span class="g-cstyle4">ad</span>o<span class="g-cstyle4">s</span> <span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>d<span class="g-cstyle4">o</span><span class="g-cstyle1">s</span></p>
    </div>
    <div id="g-ai0-56" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:53.2675%;margin-top:-6.1px;left:62.5026%;width:27px;">
      <p class="g-pstyle7">8</p>
    </div>
    <div id="g-ai0-57" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:53.2675%;margin-top:-6.1px;left:68.1488%;width:39px;">
      <p class="g-pstyle10"><span class="g-cstyle4">5</span>4<span class="g-cstyle9">.</span><span class="g-cstyle1">7</span></p>
    </div>
    <div id="g-ai0-58" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:53.2469%;margin-top:-5px;left:4.0172%;width:30px;">
      <p class="g-pstyle9"><span class="g-cstyle0">1</span>0</p>
    </div>
    <div id="g-ai0-59" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:58.2665%;margin-top:-6.8px;left:1.4441%;width:182px;">
      <p class="g-pstyle14">(<span class="g-cstyle4">*</span>) <span class="g-cstyle9">F</span>u<span class="g-cstyle4">e</span>n<span class="g-cstyle4">te</span>: Sh<span class="g-cstyle4">a</span>ngh<span class="g-cstyle4">ai</span>R<span class="g-cstyle4">a</span>n<span class="g-cstyle4">k</span>i<span class="g-cstyle4">n</span>g, AR<span class="g-cstyle4">W</span><span class="g-cstyle15">U</span><span class="g-cstyle1">.</span></p>
    </div>
    <div id="g-ai0-60" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:63.2965%;margin-top:-11.6px;left:1.4595%;width:317px;">
      <p class="g-pstyle0">RA<span class="g-cstyle0">N</span>KI<span class="g-cstyle0">N</span>G U<span class="g-cstyle0">N</span>IV<span class="g-cstyle0">E</span>RSIDAD<span class="g-cstyle0">E</span>S C<span class="g-cstyle0">H</span>ILE<span class="g-cstyle0">N</span>AS<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-61" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:68.2232%;margin-top:-6.8px;left:17.0394%;width:71px;">
      <p class="g-pstyle1"><span class="g-cstyle2">I</span>ns<span class="g-cstyle2">t</span>i<span class="g-cstyle2">t</span>u<span class="g-cstyle2">c</span>ió<span class="g-cstyle1">n</span></p>
    </div>
    <div id="g-ai0-62" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:68.0582%;margin-top:-5.6px;left:1.9755%;width:63px;">
      <p class="g-pstyle2">RA<span class="g-cstyle0">N</span>KI<span class="g-cstyle0">N</span>G<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-63" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:68.0582%;margin-top:-5.6px;left:9.5923%;width:63px;">
      <p class="g-pstyle2">RA<span class="g-cstyle0">N</span>KI<span class="g-cstyle0">N</span>G<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-64" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:68.0582%;margin-top:-5.6px;left:51.8142%;width:58px;">
      <p class="g-pstyle2">ALUM<span class="g-cstyle0">N</span>I<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-65" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:68.0582%;margin-top:-5.6px;left:59.4465%;width:57px;">
      <p class="g-pstyle2">A<span class="g-cstyle0">W</span>ARD<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-66" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:68.0582%;margin-top:-5.6px;left:68.2263%;width:41px;">
      <p class="g-pstyle2"><span class="g-cstyle0">H</span>ICI<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-67" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:68.0582%;margin-top:-5.6px;left:75.8895%;width:41px;">
      <p class="g-pstyle2"><span class="g-cstyle0">N</span>&S<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-68" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:68.0582%;margin-top:-5.6px;left:83.5526%;width:41px;">
      <p class="g-pstyle2"><span class="g-cstyle0">P</span>UB<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-69" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:68.0582%;margin-top:-5.6px;left:91.2542%;width:41px;">
      <p class="g-pstyle15">P<span class="g-cstyle2">C</span>P<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-70" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:69.3569%;margin-top:-5.6px;left:1.9755%;width:62px;">
      <p class="g-pstyle2">MU<span class="g-cstyle0">N</span>DIA<span class="g-cstyle1">L</span></p>
    </div>
    <div id="g-ai0-71" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:69.3569%;margin-top:-5.6px;left:9.1924%;width:67px;">
      <p class="g-pstyle2"><span class="g-cstyle0">N</span>ACIO<span class="g-cstyle0">N</span>A<span class="g-cstyle1">L</span></p>
    </div>
    <div id="g-ai0-72" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:73.083%;margin-top:-6.5px;left:17.3066%;width:108px;">
      <p class="g-pstyle16"><span class="g-cstyle3">U</span><span class="g-cstyle5">n</span>iv<span class="g-cstyle5">e</span>r<span class="g-cstyle5">s</span>i<span class="g-cstyle5">d</span>ad<span class="g-cstyle5"> </span>de <span class="g-cstyle5">C</span>h<span class="g-cstyle5">ile</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-73" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:73.1809%;margin-top:-6.1px;left:11.9106%;width:28px;">
      <p class="g-pstyle7"><span class="g-cstyle5">1</span> </p>
    </div>
    <div id="g-ai0-74" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:73.1809%;margin-top:-6.1px;left:53.3314%;width:36px;">
      <p class="g-pstyle6"><span class="g-cstyle13">5</span>,3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-75" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:73.1809%;margin-top:-6.1px;left:61.3566%;width:29px;">
      <p class="g-pstyle7"><span class="g-cstyle4">0</span> </p>
    </div>
    <div id="g-ai0-76" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:73.1809%;margin-top:-6.1px;left:69.035%;width:29px;">
      <p class="g-pstyle7"><span class="g-cstyle4">0</span> </p>
    </div>
    <div id="g-ai0-77" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:73.1809%;margin-top:-6.1px;left:76.3131%;width:36px;">
      <p class="g-pstyle6"><span class="g-cstyle16">8</span>,3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-78" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:73.1809%;margin-top:-6.1px;left:83.7065%;width:41px;">
      <p class="g-pstyle6">3<span class="g-cstyle6">6</span>,5<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-79" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:73.1809%;margin-top:-6.1px;left:91.4082%;width:40px;">
      <p class="g-pstyle17"><span class="g-cstyle17">1</span>4<span class="g-cstyle18">,</span><span class="g-cstyle4">9</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-80" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:73.1603%;margin-top:-5px;left:2.6686%;width:54px;">
      <p class="g-pstyle18">40<span class="g-cstyle2">1</span>-500<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-81" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:77.7006%;margin-top:-6.5px;left:17.3066%;width:182px;">
      <p class="g-pstyle5">Po<span class="g-cstyle4">n</span>ti<span class="g-cstyle4">fi</span>c<span class="g-cstyle4">i</span>a <span class="g-cstyle8">U</span><span class="g-cstyle4">ni</span>v<span class="g-cstyle4">e</span>r<span class="g-cstyle4">sid</span>a<span class="g-cstyle4">d</span> C<span class="g-cstyle8">a</span>t<span class="g-cstyle4">ó</span>l<span class="g-cstyle4">ic</span>a <span class="g-cstyle4">de</span> Ch<span class="g-cstyle4">i</span>l<span class="g-cstyle4">e</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-82" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:77.9428%;margin-top:-6.1px;left:11.88%;width:29px;">
      <p class="g-pstyle7"><span class="g-cstyle5">2</span> </p>
    </div>
    <div id="g-ai0-83" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:77.9428%;margin-top:-6.1px;left:53.693%;width:29px;">
      <p class="g-pstyle7"><span class="g-cstyle4">0</span> </p>
    </div>
    <div id="g-ai0-84" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:77.9428%;margin-top:-6.1px;left:61.3566%;width:29px;">
      <p class="g-pstyle7"><span class="g-cstyle4">0</span> </p>
    </div>
    <div id="g-ai0-85" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:77.9428%;margin-top:-6.1px;left:69.035%;width:29px;">
      <p class="g-pstyle7"><span class="g-cstyle4">0</span> </p>
    </div>
    <div id="g-ai0-86" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:77.9428%;margin-top:-6.1px;left:76.3131%;width:36px;">
      <p class="g-pstyle19"><span class="g-cstyle19">9</span>,<span class="g-cstyle4">8</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-87" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:77.9428%;margin-top:-6.1px;left:83.6908%;width:41px;">
      <p class="g-pstyle17"><span class="g-cstyle5">3</span>4<span class="g-cstyle7">,</span><span class="g-cstyle4">8</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-88" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:77.9428%;margin-top:-6.1px;left:91.4241%;width:40px;">
      <p class="g-pstyle6"><span class="g-cstyle17">1</span><span class="g-cstyle20">4</span>,3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-89" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:77.9222%;margin-top:-5px;left:2.6763%;width:54px;">
      <p class="g-pstyle18">50<span class="g-cstyle2">1</span>-600<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-90" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:82.4625%;margin-top:-6.5px;left:17.3066%;width:126px;">
      <p class="g-pstyle5"><span class="g-cstyle3">U</span>n<span class="g-cstyle4">iv</span>e<span class="g-cstyle4">r</span>s<span class="g-cstyle4">i</span>d<span class="g-cstyle4">ad</span> <span class="g-cstyle4">And</span><span class="g-cstyle8">r</span>é<span class="g-cstyle4">s</span> Bell<span class="g-cstyle4">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-91" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:82.7047%;margin-top:-6.1px;left:11.3487%;width:38px;">
      <p class="g-pstyle6">3-<span class="g-cstyle4">4</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-92" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:82.7047%;margin-top:-6.1px;left:53.693%;width:29px;">
      <p class="g-pstyle7"><span class="g-cstyle4">0</span> </p>
    </div>
    <div id="g-ai0-93" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:82.7047%;margin-top:-6.1px;left:61.3566%;width:29px;">
      <p class="g-pstyle7"><span class="g-cstyle4">0</span> </p>
    </div>
    <div id="g-ai0-94" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:82.7047%;margin-top:-6.1px;left:68.7188%;width:36px;">
      <p class="g-pstyle6"><span class="g-cstyle21">7</span>,3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-95" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:82.7047%;margin-top:-6.1px;left:76.3362%;width:36px;">
      <p class="g-pstyle6"><span class="g-cstyle22">3</span>,2<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-96" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:82.7047%;margin-top:-6.1px;left:83.6908%;width:41px;">
      <p class="g-pstyle6">2<span class="g-cstyle17">0</span>,3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-97" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:82.7047%;margin-top:-6.1px;left:91.6401%;width:36px;">
      <p class="g-pstyle20"><span class="g-cstyle16">8</span>,<span class="g-cstyle5">6</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-98" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:82.5398%;margin-top:-5px;left:2.661%;width:54px;">
      <p class="g-pstyle18">80<span class="g-cstyle2">1</span>-900<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-99" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:87.0801%;margin-top:-6.5px;left:17.3066%;width:136px;">
      <p class="g-pstyle5"><span class="g-cstyle3">U</span>n<span class="g-cstyle4">iv</span>e<span class="g-cstyle4">r</span>s<span class="g-cstyle4">i</span>d<span class="g-cstyle4">ad</span> <span class="g-cstyle4">de </span>C<span class="g-cstyle4">o</span>n<span class="g-cstyle4">c</span>epció<span class="g-cstyle4">n</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-100" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:87.3223%;margin-top:-6.1px;left:11.3487%;width:36px;">
      <p class="g-pstyle6">3-<span class="g-cstyle1">4</span></p>
    </div>
    <div id="g-ai0-101" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:87.3223%;margin-top:-6.1px;left:53.693%;width:29px;">
      <p class="g-pstyle7"><span class="g-cstyle4">0</span> </p>
    </div>
    <div id="g-ai0-102" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:87.3223%;margin-top:-6.1px;left:61.3566%;width:29px;">
      <p class="g-pstyle7"><span class="g-cstyle4">0</span> </p>
    </div>
    <div id="g-ai0-103" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:87.3223%;margin-top:-6.1px;left:69.035%;width:29px;">
      <p class="g-pstyle7"><span class="g-cstyle4">0</span> </p>
    </div>
    <div id="g-ai0-104" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:87.3223%;margin-top:-6.1px;left:76.3436%;width:36px;">
      <p class="g-pstyle21"><span class="g-cstyle13">5</span>,<span class="g-cstyle5">4</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-105" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:87.3223%;margin-top:-6.1px;left:83.714%;width:41px;">
      <p class="g-pstyle6">2<span class="g-cstyle13">5</span>,2<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-106" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:87.3223%;margin-top:-6.1px;left:91.4019%;width:40px;">
      <p class="g-pstyle6">1<span class="g-cstyle23">0</span>,2<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-107" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:87.3017%;margin-top:-5px;left:2.661%;width:54px;">
      <p class="g-pstyle18">80<span class="g-cstyle2">1</span>-900<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-108" class="g-ai2html-settings g-aiAbs" style="top:90.3319%;left:1.0833%;width:97%;">
      <p>(*)Fuente: ShanghaiRanking, ARWU / Las instituciones en el mismo rango se ordenan alfabéticamente / Alumni: exalumnos ganadores de Premios Nobel o Medallas Fields/ Award, </p>
      <p>académicos que tienen un Nobel o Medalla Fields / HiCi, investigadores altamente citados / N&S, papers publicados en Nature & Science / PUB, papers indexados en Science Citation </p>
      <p>Index Expanded (SCIE) y Social Science Citation Index (SSCI) / PCP, productividad pér capita.</p>
    </div>
  </div>

  <!-- Artboard: mobile -->
  <div id="g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-mobile" class="g-artboard" style="max-width: 320px;max-height: 967px" data-aspect-ratio="0.331" data-min-width="0" data-max-width="799">
<div style="padding: 0 0 302.1875% 0;"></div>
    <img id="g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-mobile-img" class="g-aiImg" alt="" src="${img1}"/>
    <div id="g-ai1-1" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:2.7327%;margin-top:-21.4px;left:1.442%;width:276px;">
      <p class="g-pstyle0">ACAD<span class="g-cstyle0">E</span>MIC RANKI<span class="g-cstyle0">N</span>G OF <span class="g-cstyle0">W</span>ORLD</p>
      <p class="g-pstyle0">UNIV<span class="g-cstyle0">E</span>RSI<span class="g-cstyle0">T</span>I<span class="g-cstyle0">E</span>S 202<span class="g-cstyle1">1</span></p>
    </div>
    <div id="g-ai1-2" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:5.9611%;margin-top:-5.6px;left:1.7944%;width:63px;">
      <p class="g-pstyle1">RA<span class="g-cstyle0">N</span>KI<span class="g-cstyle0">N</span>G<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-3" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:6.4929%;margin-top:-6.8px;left:16.8204%;width:71px;">
      <p class="g-pstyle2"><span class="g-cstyle2">I</span>ns<span class="g-cstyle2">t</span>i<span class="g-cstyle2">t</span>u<span class="g-cstyle2">c</span>ió<span class="g-cstyle1">n</span></p>
    </div>
    <div id="g-ai1-4" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:6.515%;margin-top:-5px;left:46.0464%;width:37px;">
      <p class="g-pstyle3">P<span class="g-cstyle0">a</span>í<span class="g-cstyle1">s</span></p>
    </div>
    <div id="g-ai1-5" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:6.6185%;margin-top:-5px;left:80.1831%;width:51px;">
      <p class="g-pstyle4">Pun<span class="g-cstyle2">ta</span>j<span class="g-cstyle2">e</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-6" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:6.7884%;margin-top:-5.6px;left:1.7944%;width:62px;">
      <p class="g-pstyle1">MU<span class="g-cstyle0">N</span>DIA<span class="g-cstyle1">L</span></p>
    </div>
    <div id="g-ai1-7" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:9.4586%;margin-top:-6.5px;left:9.9884%;width:122px;">
      <p class="g-pstyle5"><span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>v<span class="g-cstyle4">er</span>s<span class="g-cstyle4">i</span>d<span class="g-cstyle4">a</span>d d<span class="g-cstyle4">e </span>Ha<span class="g-cstyle4">r</span>vard<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-8" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:9.6322%;margin-top:-6.1px;left:57.5616%;width:83px;">
      <p class="g-pstyle6"><span class="g-cstyle4">E</span>st<span class="g-cstyle4">ad</span>o<span class="g-cstyle4">s</span> <span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>d<span class="g-cstyle4">o</span>s<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-9" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:9.6322%;margin-top:-6.1px;left:79.9249%;width:45px;">
      <p class="g-pstyle7">1<span class="g-cstyle5">0</span><span class="g-cstyle6">0</span><span class="g-cstyle7">.</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-10" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:9.514%;margin-top:-5px;left:3.2727%;width:28px;">
      <p class="g-pstyle8"><span class="g-cstyle0">1</span> </p>
    </div>
    <div id="g-ai1-11" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:12.8713%;margin-top:-6.5px;left:9.9884%;width:125px;">
      <p class="g-pstyle5"><span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>v<span class="g-cstyle4">er</span>s<span class="g-cstyle4">i</span>d<span class="g-cstyle4">a</span>d d<span class="g-cstyle4">e </span><span class="g-cstyle8">S</span>ta<span class="g-cstyle3">n</span><span class="g-cstyle4">f</span>o<span class="g-cstyle4">r</span>d<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-12" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:13.0449%;margin-top:-6.1px;left:57.5616%;width:83px;">
      <p class="g-pstyle6"><span class="g-cstyle4">E</span>st<span class="g-cstyle4">ad</span>o<span class="g-cstyle4">s</span> <span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>d<span class="g-cstyle4">o</span>s<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-13" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:13.0449%;margin-top:-6.1px;left:81.6776%;width:41px;">
      <p class="g-pstyle9">75<span class="g-cstyle9">.</span>9<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-14" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:12.9266%;margin-top:-5px;left:3.2156%;width:29px;">
      <p class="g-pstyle8"><span class="g-cstyle0">2</span> </p>
    </div>
    <div id="g-ai1-15" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:16.1805%;margin-top:-6.5px;left:9.9884%;width:135px;">
      <p class="g-pstyle5"><span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>v<span class="g-cstyle4">er</span>s<span class="g-cstyle4">i</span>d<span class="g-cstyle4">a</span>d d<span class="g-cstyle4">e </span>Cambr<span class="g-cstyle4">i</span>dge<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-16" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:16.3541%;margin-top:-6.1px;left:57.5616%;width:70px;">
      <p class="g-pstyle10"><span class="g-cstyle5">Re</span>in<span class="g-cstyle5">o</span> <span class="g-cstyle8">U</span>nid<span class="g-cstyle5">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-17" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:16.3541%;margin-top:-6.1px;left:81.5616%;width:41px;">
      <p class="g-pstyle9">7<span class="g-cstyle7">0</span><span class="g-cstyle6">.</span>6<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-18" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:16.3392%;margin-top:-5px;left:3.2346%;width:29px;">
      <p class="g-pstyle8"><span class="g-cstyle0">3</span> </p>
    </div>
    <div id="g-ai1-19" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:19.3389%;margin-top:-12px;left:9.9884%;width:123px;">
      <p class="g-pstyle5">I<span class="g-cstyle4">n</span>st<span class="g-cstyle4">it</span>ut<span class="g-cstyle4">o</span> <span class="g-cstyle10">T</span><span class="g-cstyle4">e</span>c<span class="g-cstyle4">n</span>ol<span class="g-cstyle4">ó</span>gi<span class="g-cstyle4">co</span> de </p>
      <p class="g-pstyle5">Ma<span class="g-cstyle4">s</span>sac<span class="g-cstyle4">h</span>u<span class="g-cstyle4">se</span>tt<span class="g-cstyle4">s </span>(MI<span class="g-cstyle11">T</span>)<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-20" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:19.7667%;margin-top:-6.1px;left:57.5616%;width:83px;">
      <p class="g-pstyle6"><span class="g-cstyle4">E</span>st<span class="g-cstyle4">ad</span>o<span class="g-cstyle4">s</span> <span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>d<span class="g-cstyle4">o</span>s<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-21" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:19.7667%;margin-top:-6.1px;left:81.5616%;width:41px;">
      <p class="g-pstyle9">6<span class="g-cstyle12">9</span>.<span class="g-cstyle4">5</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-22" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:19.6484%;margin-top:-5px;left:3.1587%;width:29px;">
      <p class="g-pstyle8"><span class="g-cstyle0">4</span> </p>
    </div>
    <div id="g-ai1-23" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:22.7516%;margin-top:-12px;left:9.9884%;width:130px;">
      <p class="g-pstyle5"><span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>v<span class="g-cstyle4">er</span>s<span class="g-cstyle4">i</span>d<span class="g-cstyle4">a</span>d d<span class="g-cstyle4">e </span>Ca<span class="g-cstyle4">l</span>i<span class="g-cstyle4">f</span>o<span class="g-cstyle4">r</span>nia, </p>
      <p class="g-pstyle5">B<span class="g-cstyle4">er</span><span class="g-cstyle13">k</span>el<span class="g-cstyle4">e</span>y<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-24" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:23.0759%;margin-top:-6.1px;left:57.5616%;width:83px;">
      <p class="g-pstyle6"><span class="g-cstyle4">E</span>st<span class="g-cstyle4">ad</span>o<span class="g-cstyle4">s</span> <span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>d<span class="g-cstyle4">o</span>s<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-25" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:23.0759%;margin-top:-6.1px;left:81.4087%;width:41px;">
      <p class="g-pstyle9">66<span class="g-cstyle6">.</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-26" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:23.0611%;margin-top:-5px;left:3.2346%;width:29px;">
      <p class="g-pstyle8"><span class="g-cstyle0">5</span> </p>
    </div>
    <div id="g-ai1-27" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:26.3149%;margin-top:-6.5px;left:9.9884%;width:130px;">
      <p class="g-pstyle5"><span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>v<span class="g-cstyle4">er</span>s<span class="g-cstyle4">i</span>d<span class="g-cstyle4">a</span>d d<span class="g-cstyle4">e </span>P<span class="g-cstyle4">ri</span>n<span class="g-cstyle4">ce</span>to<span class="g-cstyle4">n</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-28" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:26.4885%;margin-top:-6.1px;left:57.5616%;width:83px;">
      <p class="g-pstyle6"><span class="g-cstyle4">E</span>st<span class="g-cstyle4">ad</span>o<span class="g-cstyle4">s</span> <span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>d<span class="g-cstyle4">o</span>s<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-29" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:26.4885%;margin-top:-6.1px;left:81.7169%;width:41px;">
      <p class="g-pstyle11"><span class="g-cstyle4">5</span>9<span class="g-cstyle9">.</span><span class="g-cstyle5">7</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-30" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:26.4737%;margin-top:-5px;left:3.1966%;width:29px;">
      <p class="g-pstyle8"><span class="g-cstyle0">6</span> </p>
    </div>
    <div id="g-ai1-31" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:29.7275%;margin-top:-6.5px;left:9.9884%;width:117px;">
      <p class="g-pstyle5"><span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>v<span class="g-cstyle4">er</span>s<span class="g-cstyle4">i</span>d<span class="g-cstyle4">a</span>d d<span class="g-cstyle4">e </span>Ox<span class="g-cstyle4">fo</span>rd<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-32" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:29.9011%;margin-top:-6.1px;left:57.5616%;width:70px;">
      <p class="g-pstyle10"><span class="g-cstyle5">Re</span>in<span class="g-cstyle5">o</span> <span class="g-cstyle8">U</span>nid<span class="g-cstyle5">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-33" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:29.9011%;margin-top:-6.1px;left:81.6196%;width:41px;">
      <p class="g-pstyle9"><span class="g-cstyle4">5</span><span class="g-cstyle12">9</span>.2<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-34" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:29.7829%;margin-top:-5px;left:3.2536%;width:28px;">
      <p class="g-pstyle8"><span class="g-cstyle0">7</span> </p>
    </div>
    <div id="g-ai1-35" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:33.0367%;margin-top:-6.5px;left:9.9884%;width:128px;">
      <p class="g-pstyle5"><span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>v<span class="g-cstyle4">er</span>s<span class="g-cstyle4">i</span>d<span class="g-cstyle4">a</span>d d<span class="g-cstyle4">e </span>Co<span class="g-cstyle4">l</span>umbia<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-36" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:33.2103%;margin-top:-6.1px;left:57.5616%;width:83px;">
      <p class="g-pstyle6"><span class="g-cstyle4">E</span>st<span class="g-cstyle4">ad</span>o<span class="g-cstyle4">s</span> <span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>d<span class="g-cstyle4">o</span>s<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-37" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:33.2103%;margin-top:-6.1px;left:81.485%;width:41px;">
      <p class="g-pstyle9"><span class="g-cstyle4">5</span>8<span class="g-cstyle6">.</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-38" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:33.1955%;margin-top:-5px;left:3.1966%;width:29px;">
      <p class="g-pstyle8"><span class="g-cstyle0">8</span> </p>
    </div>
    <div id="g-ai1-39" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:36.2986%;margin-top:-12px;left:9.9884%;width:123px;">
      <p class="g-pstyle5">I<span class="g-cstyle4">n</span>st<span class="g-cstyle4">it</span>ut<span class="g-cstyle4">o</span> <span class="g-cstyle10">T</span><span class="g-cstyle4">e</span>c<span class="g-cstyle4">n</span>ol<span class="g-cstyle4">ó</span>gi<span class="g-cstyle4">co</span> de </p>
      <p class="g-pstyle5">Cal<span class="g-cstyle4">i</span>f<span class="g-cstyle4">o</span>r<span class="g-cstyle4">ni</span>a <span class="g-cstyle4">(</span>CA<span class="g-cstyle14">L</span>T<span class="g-cstyle9">E</span>C<span class="g-cstyle4">H</span>)<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-40" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:36.6229%;margin-top:-6.1px;left:57.5616%;width:83px;">
      <p class="g-pstyle6"><span class="g-cstyle4">E</span>st<span class="g-cstyle4">ad</span>o<span class="g-cstyle4">s</span> <span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>d<span class="g-cstyle4">o</span>s<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-41" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:36.6229%;margin-top:-6.1px;left:81.8329%;width:40px;">
      <p class="g-pstyle12"><span class="g-cstyle4">5</span>7<span class="g-cstyle9">.</span><span class="g-cstyle5">9</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-42" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:36.5047%;margin-top:-5px;left:3.1966%;width:29px;">
      <p class="g-pstyle8"><span class="g-cstyle0">9</span> </p>
    </div>
    <div id="g-ai1-43" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:39.7585%;margin-top:-6.5px;left:9.9884%;width:121px;">
      <p class="g-pstyle5"><span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>v<span class="g-cstyle4">er</span>s<span class="g-cstyle4">i</span>d<span class="g-cstyle4">a</span>d d<span class="g-cstyle4">e </span>Ch<span class="g-cstyle4">ic</span>ag<span class="g-cstyle1">o</span></p>
    </div>
    <div id="g-ai1-44" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:39.9321%;margin-top:-6.1px;left:57.5616%;width:81px;">
      <p class="g-pstyle6"><span class="g-cstyle4">E</span>st<span class="g-cstyle4">ad</span>o<span class="g-cstyle4">s</span> <span class="g-cstyle3">U</span>n<span class="g-cstyle4">i</span>d<span class="g-cstyle4">o</span><span class="g-cstyle1">s</span></p>
    </div>
    <div id="g-ai1-45" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:39.9321%;margin-top:-6.1px;left:81.622%;width:39px;">
      <p class="g-pstyle9"><span class="g-cstyle4">5</span>4<span class="g-cstyle9">.</span><span class="g-cstyle1">7</span></p>
    </div>
    <div id="g-ai1-46" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:39.9174%;margin-top:-5px;left:2.5429%;width:30px;">
      <p class="g-pstyle8"><span class="g-cstyle0">1</span>0</p>
    </div>
    <div id="g-ai1-47" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:43.5146%;margin-top:-6.8px;left:0.4852%;width:182px;">
      <p class="g-pstyle13">(<span class="g-cstyle4">*</span>) <span class="g-cstyle9">F</span>u<span class="g-cstyle4">e</span>n<span class="g-cstyle4">te</span>: Sh<span class="g-cstyle4">a</span>ngh<span class="g-cstyle4">ai</span>R<span class="g-cstyle4">a</span>n<span class="g-cstyle4">k</span>i<span class="g-cstyle4">n</span>g, AR<span class="g-cstyle4">W</span><span class="g-cstyle15">U</span><span class="g-cstyle1">.</span></p>
    </div>
    <div id="g-ai1-48" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:48.1535%;margin-top:-11.6px;left:1.4612%;width:317px;">
      <p class="g-pstyle0">RA<span class="g-cstyle0">N</span>KI<span class="g-cstyle0">N</span>G U<span class="g-cstyle0">N</span>IV<span class="g-cstyle0">E</span>RSIDAD<span class="g-cstyle0">E</span>S C<span class="g-cstyle0">H</span>ILE<span class="g-cstyle0">N</span>AS<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-49" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:52.4081%;margin-top:-6.8px;left:25.7236%;width:71px;">
      <p class="g-pstyle2"><span class="g-cstyle2">I</span>ns<span class="g-cstyle2">t</span>i<span class="g-cstyle2">t</span>u<span class="g-cstyle2">c</span>ió<span class="g-cstyle1">n</span></p>
    </div>
    <div id="g-ai1-50" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:52.3933%;margin-top:-5.6px;left:13.6061%;width:53px;">
      <p class="g-pstyle14">R. NAC.</p>
    </div>
    <div id="g-ai1-51" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:52.3848%;margin-top:-5.6px;left:1.1888%;width:58px;">
      <p class="g-pstyle1">R.MUND.</p>
    </div>
    <div id="g-ai1-52" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:55.2704%;margin-top:-6.5px;left:26.0791%;width:108px;">
      <p class="g-pstyle15"><span class="g-cstyle3">U</span><span class="g-cstyle5">n</span>iv<span class="g-cstyle5">e</span>r<span class="g-cstyle5">s</span>i<span class="g-cstyle5">d</span>ad<span class="g-cstyle5"> </span>de <span class="g-cstyle5">C</span>h<span class="g-cstyle5">ile</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-53" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:55.2372%;margin-top:-6.1px;left:16.339%;width:28px;">
      <p class="g-pstyle16"><span class="g-cstyle5">1</span> </p>
    </div>
    <div id="g-ai1-54" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:55.2224%;margin-top:-5px;left:1.6716%;width:54px;">
      <p class="g-pstyle17">40<span class="g-cstyle2">1</span>-500<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-55" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:58.5796%;margin-top:-6.5px;left:26.0791%;width:182px;">
      <p class="g-pstyle5">Po<span class="g-cstyle4">n</span>ti<span class="g-cstyle4">fi</span>c<span class="g-cstyle4">i</span>a <span class="g-cstyle8">U</span><span class="g-cstyle4">ni</span>v<span class="g-cstyle4">e</span>r<span class="g-cstyle4">sid</span>a<span class="g-cstyle4">d</span> C<span class="g-cstyle8">a</span>t<span class="g-cstyle4">ó</span>l<span class="g-cstyle4">ic</span>a <span class="g-cstyle4">de</span> Ch<span class="g-cstyle4">i</span>l<span class="g-cstyle4">e</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-56" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:58.6498%;margin-top:-6.1px;left:16.2625%;width:29px;">
      <p class="g-pstyle16"><span class="g-cstyle5">2</span> </p>
    </div>
    <div id="g-ai1-57" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:58.6351%;margin-top:-5px;left:1.6907%;width:54px;">
      <p class="g-pstyle17">50<span class="g-cstyle2">1</span>-600<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-58" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:61.9922%;margin-top:-6.5px;left:26.0791%;width:126px;">
      <p class="g-pstyle5"><span class="g-cstyle3">U</span>n<span class="g-cstyle4">iv</span>e<span class="g-cstyle4">r</span>s<span class="g-cstyle4">i</span>d<span class="g-cstyle4">ad</span> <span class="g-cstyle4">And</span><span class="g-cstyle8">r</span>é<span class="g-cstyle4">s</span> Bell<span class="g-cstyle4">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-59" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:62.0624%;margin-top:-6.1px;left:14.9342%;width:38px;">
      <p class="g-pstyle6">3-<span class="g-cstyle4">4</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-60" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:61.9443%;margin-top:-5px;left:1.6525%;width:54px;">
      <p class="g-pstyle17">80<span class="g-cstyle2">1</span>-900<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-61" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:65.3014%;margin-top:-6.5px;left:26.0791%;width:136px;">
      <p class="g-pstyle5"><span class="g-cstyle3">U</span>n<span class="g-cstyle4">iv</span>e<span class="g-cstyle4">r</span>s<span class="g-cstyle4">i</span>d<span class="g-cstyle4">ad</span> <span class="g-cstyle4">de </span>C<span class="g-cstyle4">o</span>n<span class="g-cstyle4">c</span>epció<span class="g-cstyle4">n</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-62" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:65.3716%;margin-top:-6.1px;left:14.9342%;width:36px;">
      <p class="g-pstyle6">3-<span class="g-cstyle1">4</span></p>
    </div>
    <div id="g-ai1-63" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:65.3569%;margin-top:-5px;left:1.6525%;width:54px;">
      <p class="g-pstyle17">80<span class="g-cstyle2">1</span>-900<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-64" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:69.9735%;margin-top:-5.6px;left:27.6605%;width:58px;">
      <p class="g-pstyle1">ALUM<span class="g-cstyle0">N</span>I<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-65" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:69.9735%;margin-top:-5.6px;left:40.4913%;width:57px;">
      <p class="g-pstyle1">A<span class="g-cstyle0">W</span>ARD<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-66" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:69.9735%;margin-top:-5.6px;left:55.5658%;width:41px;">
      <p class="g-pstyle1"><span class="g-cstyle0">H</span>ICI<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-67" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:69.9735%;margin-top:-5.6px;left:67.2238%;width:41px;">
      <p class="g-pstyle1"><span class="g-cstyle0">N</span>&S<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-68" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:69.9735%;margin-top:-5.6px;left:78.569%;width:41px;">
      <p class="g-pstyle1"><span class="g-cstyle0">P</span>UB<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-69" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:69.9735%;margin-top:-5.6px;left:90.3229%;width:41px;">
      <p class="g-pstyle14">P<span class="g-cstyle2">C</span>P<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-70" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:73.6191%;margin-top:-11.9px;left:3.2666%;width:72px;">
      <p class="g-pstyle15"><span class="g-cstyle3">U</span><span class="g-cstyle5">n</span>iv<span class="g-cstyle5">e</span>r<span class="g-cstyle5">s</span>i<span class="g-cstyle5">d</span>ad<span class="g-cstyle5"> </span></p>
      <p class="g-pstyle5"><span class="g-cstyle4">de </span>C<span class="g-cstyle4">h</span>ile<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-71" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:73.6446%;margin-top:-6.1px;left:31.4536%;width:36px;">
      <p class="g-pstyle6"><span class="g-cstyle13">5</span>,3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-72" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:73.6446%;margin-top:-6.1px;left:45.2664%;width:29px;">
      <p class="g-pstyle16"><span class="g-cstyle4">0</span> </p>
    </div>
    <div id="g-ai1-73" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:73.6446%;margin-top:-6.1px;left:57.5876%;width:29px;">
      <p class="g-pstyle16"><span class="g-cstyle4">0</span> </p>
    </div>
    <div id="g-ai1-74" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:73.6446%;margin-top:-6.1px;left:68.2828%;width:36px;">
      <p class="g-pstyle6"><span class="g-cstyle16">8</span>,3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-75" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:73.6446%;margin-top:-6.1px;left:78.9539%;width:41px;">
      <p class="g-pstyle6">3<span class="g-cstyle6">6</span>,5<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-76" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:73.6446%;margin-top:-6.1px;left:90.708%;width:40px;">
      <p class="g-pstyle18"><span class="g-cstyle17">1</span>4<span class="g-cstyle18">,</span><span class="g-cstyle4">9</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-77" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:76.7661%;margin-top:-17.3px;left:3.2666%;width:107px;">
      <p class="g-pstyle5">Po<span class="g-cstyle4">n</span>ti<span class="g-cstyle4">fi</span>c<span class="g-cstyle4">i</span>a </p>
      <p class="g-pstyle15"><span class="g-cstyle8">U</span>ni<span class="g-cstyle5">v</span>e<span class="g-cstyle5">r</span>sid<span class="g-cstyle5">a</span>d<span class="g-cstyle5"> C</span><span class="g-cstyle8">a</span><span class="g-cstyle5">t</span>ó<span class="g-cstyle5">l</span>ic<span class="g-cstyle5">a </span></p>
      <p class="g-pstyle5"><span class="g-cstyle4">de</span> Ch<span class="g-cstyle4">i</span>l<span class="g-cstyle4">e</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-78" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:77.0572%;margin-top:-6.1px;left:32.3575%;width:29px;">
      <p class="g-pstyle16"><span class="g-cstyle4">0</span> </p>
    </div>
    <div id="g-ai1-79" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:77.0572%;margin-top:-6.1px;left:45.2664%;width:29px;">
      <p class="g-pstyle16"><span class="g-cstyle4">0</span> </p>
    </div>
    <div id="g-ai1-80" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:77.0572%;margin-top:-6.1px;left:57.5876%;width:29px;">
      <p class="g-pstyle16"><span class="g-cstyle4">0</span> </p>
    </div>
    <div id="g-ai1-81" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:77.0572%;margin-top:-6.1px;left:68.2828%;width:36px;">
      <p class="g-pstyle19"><span class="g-cstyle19">9</span>,<span class="g-cstyle4">8</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-82" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:77.0572%;margin-top:-6.1px;left:78.9145%;width:41px;">
      <p class="g-pstyle18"><span class="g-cstyle5">3</span>4<span class="g-cstyle7">,</span><span class="g-cstyle4">8</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-83" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:77.0572%;margin-top:-6.1px;left:90.7477%;width:40px;">
      <p class="g-pstyle6"><span class="g-cstyle17">1</span><span class="g-cstyle20">4</span>,3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-84" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:80.1341%;margin-top:-11.9px;left:3.2666%;width:75px;">
      <p class="g-pstyle15"><span class="g-cstyle3">U</span><span class="g-cstyle5">n</span>iv<span class="g-cstyle5">e</span>r<span class="g-cstyle5">s</span>i<span class="g-cstyle5">d</span>ad</p>
      <p class="g-pstyle5"><span class="g-cstyle4">And</span><span class="g-cstyle8">r</span>é<span class="g-cstyle4">s</span> Bell<span class="g-cstyle4">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-85" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:80.4699%;margin-top:-6.1px;left:32.3575%;width:29px;">
      <p class="g-pstyle16"><span class="g-cstyle4">0</span> </p>
    </div>
    <div id="g-ai1-86" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:80.4699%;margin-top:-6.1px;left:45.2664%;width:29px;">
      <p class="g-pstyle16"><span class="g-cstyle4">0</span> </p>
    </div>
    <div id="g-ai1-87" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:80.4699%;margin-top:-6.1px;left:56.7969%;width:36px;">
      <p class="g-pstyle6"><span class="g-cstyle21">7</span>,3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-88" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:80.4699%;margin-top:-6.1px;left:68.3405%;width:36px;">
      <p class="g-pstyle6"><span class="g-cstyle22">3</span>,2<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-89" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:80.4699%;margin-top:-6.1px;left:78.9145%;width:41px;">
      <p class="g-pstyle6">2<span class="g-cstyle17">0</span>,3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-90" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:80.4699%;margin-top:-6.1px;left:91.2878%;width:36px;">
      <p class="g-pstyle20"><span class="g-cstyle16">8</span>,<span class="g-cstyle5">6</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-91" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:83.4433%;margin-top:-11.9px;left:3.5791%;width:86px;">
      <p class="g-pstyle15"><span class="g-cstyle3">U</span><span class="g-cstyle5">n</span>iv<span class="g-cstyle5">e</span>r<span class="g-cstyle5">s</span>i<span class="g-cstyle5">d</span>ad<span class="g-cstyle5"> </span></p>
      <p class="g-pstyle5"><span class="g-cstyle4">de </span>C<span class="g-cstyle4">o</span>n<span class="g-cstyle4">c</span>epció<span class="g-cstyle4">n</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-92" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:83.7791%;margin-top:-6.1px;left:32.3575%;width:29px;">
      <p class="g-pstyle16"><span class="g-cstyle4">0</span> </p>
    </div>
    <div id="g-ai1-93" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:83.7791%;margin-top:-6.1px;left:45.2664%;width:29px;">
      <p class="g-pstyle16"><span class="g-cstyle4">0</span> </p>
    </div>
    <div id="g-ai1-94" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:83.7791%;margin-top:-6.1px;left:57.5876%;width:29px;">
      <p class="g-pstyle16"><span class="g-cstyle4">0</span> </p>
    </div>
    <div id="g-ai1-95" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:83.7791%;margin-top:-6.1px;left:68.3591%;width:36px;">
      <p class="g-pstyle21"><span class="g-cstyle13">5</span>,<span class="g-cstyle5">4</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-96" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:83.7791%;margin-top:-6.1px;left:78.9725%;width:41px;">
      <p class="g-pstyle6">2<span class="g-cstyle13">5</span>,2<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-97" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:83.7791%;margin-top:-6.1px;left:90.6921%;width:40px;">
      <p class="g-pstyle6">1<span class="g-cstyle23">0</span>,2<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-98" class="g-ai2html-settings g-aiAbs" style="top:86.1427%;left:2.0833%;width:94.0625%;">
      <p>(*)Fuente: ShanghaiRanking, ARWU / Las instituciones en el mismo rango se ordenan alfabéticamente / Alumni: exalumnos ganadores de Premios Nobel o Medallas Fields/ Award, </p>
      <p>académicos que tienen un Nobel o Medalla Fields / HiCi, investigadores altamente citados / N&S, papers publicados en Nature & Science / PUB, papers indexados en Science Citation </p>
      <p>Index Expanded (SCIE) y Social Science Citation Index (SSCI) / PCP, productividad pér capita.</p>
    </div>
  </div>


</div>
`

const containerId =
  'g-01-ranking-shanghai-academic-ranking-of-world-universities-2021-box'
const namespace = 'g-'
const name = '01-ranking-shanghai-academic-ranking-of-world-universities-2021'

export default makeAi2React({ html, styles, containerId, namespace, name })

/* End ai2react - 2021-09-14 00:49 */
